<template>
  <form>
    <div class="row mt-3">
      <div class="col-lg-4">
        <h4 class="card-title">{{$t('small_technical_grants.general_info__project_title_card_title')}}</h4>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.titleOfProject"
            v-model="GrantForm.title"
            :error="getError('technical.titleOfProject')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_title_of_project')"
            :label="$t('medium_grant.technical__1_title_of_project')"
            :placeholder="$t('small_technical_grants.general_info__project_title_placeholder')"
          >
          </textarea>
        </div>
        <h4 class="card-title">{{$t('small_technical_grants.general_info__lead_applicant_name_card_title')}}</h4>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.leadApplicantName"
            v-model="GrantForm.model.technical.leadApplicantName"
            :error="getError('technical.leadApplicantName')"
            v-validate="'required'"
            :placeholder="$t('small_technical_grants.general_info__lead_applicant_name_placeholder')"
          >
          </textarea>
        </div>
        <h4 class="card-title">{{$t('small_technical_grants.general_info__lead_applicant_organisation_card_title')}}</h4>
        <div class="form-group">
          <h6>
            {{$t('small_technical_grants.general_info__lead_applicant_organisation_instructions')}}
          </h6>
          <div class="mt-4"></div>
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.organisationTypeGovernment">
            {{$t('small_technical_grants.general_info__lead_applicant_organisation_checkbox_1')}}
          </base-checkbox>
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.organisationTypeProtected">
            {{$t('small_technical_grants.general_info__lead_applicant_organisation_checkbox_2')}}
          </base-checkbox>
        </div>
        <h4 class="card-title">{{$t('small_technical_grants.general_info__co_applicant_name_card_title')}}</h4>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.nameOfCoApplicants"
            v-model="GrantForm.model.technical.nameOfCoApplicants"
            :error="getError('technical.nameOfCoApplicants')"
            v-validate="'required'"
            :placeholder="$t('small_technical_grants.general_info__co_applicant_name_placeholder')"
          >
          </textarea>
        </div>
        <h4 class="card-title">{{$t('small_technical_grants.general_info__co_applicant_organisation_card_title')}}</h4>
        <div class="form-group">
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.coApplicantOrganisationTypeGovernment">
            {{$t('small_technical_grants.general_info__co_applicant_organisation_checkbox_1')}}
          </base-checkbox>
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.coApplicantOrganisationTypeProtected">
            {{$t('small_technical_grants.general_info__co_applicant_organisation_checkbox_2')}}
          </base-checkbox>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.general_info__region_card_title')}}</h4>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__1_region')}}</label>
          <select class="form-control"
            @change="setRegion"
            name="technical.region"
            id="regionSelect"
            :error="getError('technical.region')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_region')"
          >
            <option value="" selected="selected">{{$t('medium_grant.general__please_select')}}</option>
            <option :value="region.regionId" :selected="GrantForm.regionId === region.regionId" v-for="region in regions" :key="region.regionId">{{region.code}} - {{region.name}}</option>
          </select>
          <label v-if="getError('technical.region')" class="error text-danger">{{getError('technical.region')}}</label>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.general_info__acp_country_card_title')}}</h4>
        <div class="form-group" :class="{'has-danger': getError('technical.acpCountry')}">
          <label for="countrySelect">{{$t('medium_grant.technical__1_acp_country')}}</label>
          <multiselect name="technical.acpCountry" v-model="GrantForm.model.technical.acpCountry" selectLabel="" selectedLabel="" deselectLabel="Clear" v-validate="'required'" :data-vv-as="$t('medium_grant.technical__1_acp_country')" :tag-placeholder="$t('medium_grant.general__please_select')" :placeholder="$t('medium_grant.general__please_select')" label="name" track-by="countryId" :options="countriesByRegion" :multiple="true"></multiselect>
          <label v-if="getError('technical.acpCountry')" class="error text-danger">{{getError('technical.acpCountry')}}</label>
        </div>
      </div>
      <div class="col-lg-4">
        <h4 class="card-title">{{$t('small_technical_grants.general_info__priority_area_targeted_card_title')}}</h4>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.priorityAreaTargeted"
            v-model="GrantForm.model.technical.priorityAreaTargeted"
            :error="getError('technical.priorityAreaTargeted')"
            v-validate="'required'"
            :placeholder="$t('small_technical_grants.general_info__priority_area_targeted_placeholder')"
          >
          </textarea>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.general_info__pa_registration_number_card_title')}}</h4>
        <h6>{{$t('small_technical_grants.general_info__pa_registration_number_instructions')}}</h6>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.paRegistrationNumber"
            v-model="GrantForm.model.technical.paRegistrationNumber"
            :error="getError('technical.paRegistrationNumber')"
            v-validate="'required'"
            :placeholder="$t('small_technical_grants.general_info__pa_registration_number_placeholder')"
          >
          </textarea>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.general_info__pa_supervisory_authority_card_title')}}</h4>
        <h6>{{$t('small_technical_grants.general_info__pa_supervisory_authority_instructions')}}</h6>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.paSupervisoryAuthority"
            v-model="GrantForm.model.technical.paSupervisoryAuthority"
            :error="getError('technical.paSupervisoryAuthority')"
            v-validate="'required'"
            :placeholder="$t('small_technical_grants.general_info__pa_supervisory_authority_placeholder')"
          >
          </textarea>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              name="technical.startDate"
              v-model="GrantForm.model.technical.startDate"
              :error="getError('technical.startDate')"
              v-validate="'required'"
              :data-vv-as="$t('medium_grant.technical__1_startdate')"
              :placeholder="$t('medium_grant.technical__1_startdate')"
            >
              <label>{{$t('medium_grant.technical__1_startdate')}}</label>
              <el-date-picker
                type="date"
                v-model="startDate"
                :placeholder="$t('medium_grant.technical__1_startdate')"
              >
              </el-date-picker>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              name="technical.endDate"
              v-model="GrantForm.model.technical.endDate"
              :placeholder="$t('medium_grant.technical__1_enddate')"
              :error="getError('technical.endDate')"
              v-validate="'required'"
              :data-vv-as="$t('medium_grant.technical__1_enddate')"
            >
              <label>{{$t('medium_grant.technical__1_enddate')}}</label>
              <el-date-picker
                type="date"
                v-model="endDate"
                :placeholder="$t('medium_grant.technical__1_enddate')"
              >
              </el-date-picker>
            </base-input>
          </div>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.general_info__duration_card_title')}}</h4>
        <div class="form-group">
          <textarea
            class="form-control"
            name="technical.duration"
            v-model="GrantForm.model.technical.duration"
            :error="getError('technical.duration')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_duration')"
            :label="$t('medium_grant.technical__1_duration')"
            :placeholder="$t('medium_grant.technical__1_duration')"
          >
          </textarea>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.general_info__total_annual_budget_card_title')}}</h4>
        <div class="form-group">
          <currency-input
            class="form-control"
            name="technical.totalPaAnualBudget"
            v-model="GrantForm.model.technical.totalPaAnualBudget"
            :error="getError('technical.totalPaAnualBudget')"
            currency="EUR"
            locale="de"
            v-validate="'required'"
            :placeholder="$t('small_technical_grants.general_info__total_annual_budget_placeholder')"
          />
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.general_info__total_funding_requested_card_title')}}</h4>
        <div class="form-group">
          <currency-input
            class="form-control"
            name="technical.totalFundingRequested"
            v-model="GrantForm.model.technical.totalFundingRequested"
            :error="getError('technical.totalFundingRequested')"
            v-validate="'required'"
            currency="EUR"
            locale="de"
            :placeholder="$t('small_technical_grants.general_info__total_annual_budget_placeholder')"
          />
        </div>
      </div>
      <div class="col-lg-4">
        <h4 class="card-title">{{$t('small_technical_grants.general_info__action_component_objectives_card_title')}}</h4>
        <div class="form-group">
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.enhanceManagement">
            {{$t('small_technical_grants.general_info__action_component_objectives_checkbox_1')}}
          </base-checkbox>
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.enforceLegalFramework">
            {{$t('small_technical_grants.general_info__action_component_objectives_checkbox_2')}}
          </base-checkbox>
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.supportLocalCommunities">
            {{$t('small_technical_grants.general_info__action_component_objectives_checkbox_3')}}
          </base-checkbox>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.general_info__diagnostic_tool_card_title')}}</h4>
        <div class="form-group">
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.diagnosticQuantifiedManagement">
            {{$t('small_technical_grants.general_info__diagnostic_tool_checkbox_1')}}
          </base-checkbox>
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.diagnosticStategicDocuments">
            {{$t('small_technical_grants.general_info__diagnostic_tool_checkbox_2')}}
          </base-checkbox>
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.diagnosticStudies">
            {{$t('small_technical_grants.general_info__diagnostic_tool_checkbox_3')}}
          </base-checkbox>
          <base-checkbox name="checkbox" v-model="GrantForm.model.technical.diagnosticNotApplicable">
            {{$t('small_technical_grants.general_info__diagnostic_tool_checkbox_4')}}
          </base-checkbox>
          <h6 class="mt-3" style="color: red">{{$t('small_technical_grants.general_info__diagnostic_tool_warn')}}</h6>
          <textarea
            class="form-control"
            name="technical.diagnosticToolReference"
            v-model="GrantForm.model.technical.diagnosticToolReference"
            :error="getError('technical.diagnosticToolReference')"
            v-validate="'required'"
            :placeholder="$t('small_technical_grants.general_info__diagnostic_tool_placeholder')"
          >
          </textarea>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.general_info__priorities_for_action_card_title')}}</h4>
        <div class="form-group">
          <h6>{{$t('small_technical_grants.general_info__priorities_for_action_instructions_1')}}</h6>
          <h6>{{$t('small_technical_grants.general_info__priorities_for_action_instructions_2')}}</h6>
          <textarea
            class="form-control"
            name="technical.prioritiesForAction"
            v-model="GrantForm.model.technical.prioritiesForAction"
            :error="getError('technical.prioritiesForAction')"
            v-validate="'required'"
            rows="5"
            :placeholder="$t('small_technical_grants.general_info__priorities_for_action_placeholder')"
          >
          </textarea>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import VueCurrencyInput from 'vue-currency-input';

  import {DatePicker} from 'element-ui';
  import Multiselect from 'vue-multiselect';
  import {GrantForm, RegionService} from "@/services";
  import {BaseAlert} from 'src/components';

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      Multiselect,
      BaseAlert,
      VueCurrencyInput,
    },
    data() {
      return {
        GrantForm,
        startDate: '',
        endDate: '',
        moment: '',
        regions: [],
        options: [],
        value: [],
        downloadFiles: {
          en: '/files/en/Application_template_BIOPAMA_medium_grants_2019_EN.docx',
          fr: '/files/fr/Application_template_BIOPAMA_medium_grants_2019_FR.docx'
        }
      }
    },
    computed: {
      countriesByRegion() {
        let countries = [];
        let region = this.regions.filter((region) => {
          return region.regionId === GrantForm.regionId;
        })
        if (region[0] !== undefined && region[0].countries !== undefined && region[0].countries.length) {
          countries = region[0].countries;
        }
        return countries;
      }
    },
    async beforeMount() {
      this.moment = require('moment');

      let loader = this.$loading.show();
      let vm = this;
      RegionService.getApplicationRegionsWithCountries().then(function (response) {
        vm.regions = response.data;

        loader.hide();
      })

      if (GrantForm.model.technical.startDate !== undefined) {
        this.startDate = GrantForm.model.technical.startDate;
      }

      if (GrantForm.model.technical.endDate !== undefined) {
        this.endDate = GrantForm.model.technical.endDate;
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      setRegion(event) {
        GrantForm.regionId = parseInt(event.target.value);
        GrantForm.model.technical.acpCountry = [];
      }
    },
    watch: {
      startDate(newValue, oldValue) {
        GrantForm.model.technical.startDate = this.moment(newValue).format('YYYY-MM-DD');
      },
      endDate(newValue, oldValue) {
        GrantForm.model.technical.endDate = this.moment(newValue).format('YYYY-MM-DD');
      }
    }
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }

  textarea.form-control, .form-group textarea.el-input__inner, .el-date-picker .el-input textarea.el-input__inner
  {
    border: 1px solid #2b3553;
    border-radius: 5px;
  }
</style>
